module.exports = {
  id: 11,
  name: 'One Leg Stand',
  categories: ['balance', 'core', 'strength'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Balance',
  points: 12,
  instructions:
    'One Leg Stand makes you balanced like a flamingo! Stand with your feet together, lift one leg up and hold it there, then switch to the other leg! This builds incredible balance and core strength!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to stand on one leg like a flamingo?',
    },
    {
      time: 3,
      text: "Let's build incredible balance!",
    },
    {
      time: 6,
      text: '3, 2, 1, START!',
    },
    // SET 1 - 3 reps (20 seconds per leg)
    {
      time: 9,
      text: 'Number 1! Lift your right leg up and hold it steady!',
    },
    {
      time: 12,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 15,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 18,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 21,
      text: 'Keep your balance, almost there!',
    },
    {
      time: 24,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 27,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 30,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 33,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 36,
      text: 'Keep your balance, almost there!',
    },
    {
      time: 39,
      text: 'Great job! Number 2! Lift your right leg up and hold it steady!',
    },
    {
      time: 42,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 45,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 48,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 51,
      text: 'Keep your balance, almost there!',
    },
    {
      time: 54,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 57,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 60,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 63,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 66,
      text: 'Keep your balance, almost there!',
    },
    {
      time: 69,
      text: 'Great job! Number 3! Lift your right leg up and hold it steady!',
    },
    {
      time: 72,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 75,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 78,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 81,
      text: 'Keep your balance, almost there!',
    },
    {
      time: 84,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 87,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 90,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 93,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 96,
      text: 'Keep your balance, almost there!',
    },
    {
      time: 99,
      text: 'Incredible balance! Take a break.',
    },
    // REST PERIOD 1 - 30 seconds
    {
      time: 102,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 105,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 108,
      text: 'You are building incredible balance!',
    },
    {
      time: 111,
      text: 'Ready for round two?',
    },
    {
      time: 114,
      text: '3, 2, 1, START!',
    },
    // SET 2 - 3 reps (25 seconds per leg)
    {
      time: 117,
      text: 'Number 1! Lift your right leg up and hold it steady!',
    },
    {
      time: 120,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 123,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 126,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 129,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 132,
      text: 'Hold your right leg up, almost there!',
    },
    {
      time: 135,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 138,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 141,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 144,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 147,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 150,
      text: 'Hold your left leg up, almost there!',
    },
    {
      time: 153,
      text: 'Great job! Number 2! Lift your right leg up and hold it steady!',
    },
    {
      time: 156,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 159,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 162,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 165,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 168,
      text: 'Hold your right leg up, almost there!',
    },
    {
      time: 171,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 174,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 177,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 180,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 183,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 186,
      text: 'Hold your left leg up, almost there!',
    },
    {
      time: 189,
      text: 'Great job! Number 3! Lift your right leg up and hold it steady!',
    },
    {
      time: 192,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 195,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 198,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 201,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 204,
      text: 'Hold your right leg up, almost there!',
    },
    {
      time: 207,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 210,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 213,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 216,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 219,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 222,
      text: 'Hold your left leg up, almost there!',
    },
    {
      time: 225,
      text: 'Incredible balance! Take another break.',
    },
    // REST PERIOD 2 - 30 seconds
    {
      time: 228,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 231,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 234,
      text: 'You are building incredible balance!',
    },
    {
      time: 237,
      text: 'Ready for the final round?',
    },
    {
      time: 240,
      text: '3, 2, 1, START!',
    },
    // SET 3 - 3 reps (30 seconds per leg)
    {
      time: 243,
      text: 'Number 1! Lift your right leg up and hold it steady!',
    },
    {
      time: 246,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 249,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 252,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 255,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 258,
      text: 'Hold your right leg up, keep going!',
    },
    {
      time: 261,
      text: 'Hold your right leg up, almost there!',
    },
    {
      time: 264,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 267,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 270,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 273,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 276,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 279,
      text: 'Hold your left leg up, keep going!',
    },
    {
      time: 282,
      text: 'Hold your left leg up, almost there!',
    },
    {
      time: 285,
      text: 'Great job! Number 2! Lift your right leg up and hold it steady!',
    },
    {
      time: 288,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 291,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 294,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 297,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 300,
      text: 'Hold your right leg up, keep going!',
    },
    {
      time: 303,
      text: 'Hold your right leg up, almost there!',
    },
    {
      time: 306,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 309,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 312,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 315,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 318,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 321,
      text: 'Hold your left leg up, keep going!',
    },
    {
      time: 324,
      text: 'Hold your left leg up, almost there!',
    },
    {
      time: 327,
      text: 'Great job! Number 3! Lift your right leg up and hold it steady!',
    },
    {
      time: 330,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 333,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 336,
      text: 'Hold your right leg up, you are doing great!',
    },
    {
      time: 339,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 342,
      text: 'Hold your right leg up, keep going!',
    },
    {
      time: 345,
      text: 'Hold your right leg up, almost there!',
    },
    {
      time: 348,
      text: 'Now switch to your left leg and hold it steady!',
    },
    {
      time: 351,
      text: 'Keep your balance like a flamingo!',
    },
    {
      time: 354,
      text: 'Stay focused and keep your core engaged!',
    },
    {
      time: 357,
      text: 'Hold your left leg up, you are doing great!',
    },
    {
      time: 360,
      text: 'Keep your balance, stay strong!',
    },
    {
      time: 363,
      text: 'Hold your left leg up, keep going!',
    },
    {
      time: 366,
      text: 'Hold your left leg up, almost there!',
    },
    {
      time: 369,
      text: 'Incredible work! You are done!',
    },
    // COMPLETION
    {
      time: 372,
      text: 'Amazing work! You just held 18 one-leg stands!',
    },
    {
      time: 375,
      text: 'You are building incredible balance and core strength!',
    },
    {
      time: 378,
      text: 'Great job, balance champion!',
    },
  ],
};
